import { render, staticRenderFns } from "./MySkinSos.vue?vue&type=template&id=71426d6a"
import script from "./MySkinSos.vue?vue&type=script&lang=js"
export * from "./MySkinSos.vue?vue&type=script&lang=js"
import style0 from "./mySkinSOS.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports